import moment from 'moment';
import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import './ExternalDataHistorySearchComponent.css';
import {
  Box, Typography, TextField, FormControlLabel, Grid, Button,
} from '@material-ui/core';
import { Search, Refresh } from '@material-ui/icons';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import { setSystemLodingFLg, setErrorMessage } from '../../actions/CommonAction';
import {
  setInitExternalDataHistoryState,
  setProcessNoFrom,
  setProcessNoTo,
  setCooperationDateFrom,
  setCooperationDateTo,
  setStatus,
  setTsrCd,
  setTsrCompanyCd,
  setTradeKey,
  setNowPage,
  setExternalDataHistoryList,
  setInitSearchCondition,
  searchExternalDataHistory,
  setErrProcessNoFromMsg,
  setErrProcessNoToMsg,
  setErrCooperationDateFromMsg,
  setErrCooperationDateToMsg,
  setErrTsrCdMsg,
  setErrTsrCompanyCdMsg,
  setErrTradeKeyMsg,
  setErrProcessNoFromFlg,
  setErrProcessNoToFlg,
  setErrCooperationDateFromFlg,
  setErrCooperationDateToFlg,
  setErrTsrCdFlg,
  setErrTsrCompanyCdFlg,
  setErrTradeKeyFlg,
  setLimitMessage,
  startImportPolling,
  stopImportPolling,
} from '../../actions/ExternalDataHistoryAction';
import {
  EXTERNALDATA_STATUS,
  INPUT,
  DATE_TIME_FORMAT,
} from '../../../common/const';

import CustomCheckbox from '../common/CustomCheckbox';

class ExternalDataHistorySearchComponent extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  /**
  * 処理番号FROM
  */
onBlurProcessNoFrom = () => {
  const {
    processNoFrom,
    processNoTo,
    setErrProcessNoFromMsgAct,
    setErrProcessNoFromFlgAct,
    setErrProcessNoToFlgAct,
    setErrProcessNoToMsgAct,
  } = this.props;
  const errMsg = [];
  if (processNoFrom && processNoFrom.length > 0) {
    // 文字種チェック(半角数字)
    validator.checkChar(processNoFrom, VALIDATOR_CONST.PATERN_NUM, errMsg);
    // 桁数チェック
    validator.checkLength(processNoFrom, 10, errMsg);
    if (errMsg.length !== 0) {
      setErrProcessNoFromFlgAct(true);
      setErrProcessNoFromMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
      return;
    }
    // 入力値チェック
    if (processNoTo && processNoFrom > processNoTo) {
      setErrProcessNoFromFlgAct(true);
      setErrProcessNoToFlgAct(true);
      setErrProcessNoFromMsgAct(getMessage('FROMに、TOを超える値が入力されています。'));
      return;
    }
    if (processNoTo && processNoTo.length === 10 && processNoFrom <= processNoTo) {
      setErrProcessNoToFlgAct(false);
      setErrProcessNoToMsgAct();
    }
  }
  setErrProcessNoFromFlgAct(false);
  setErrProcessNoFromMsgAct();
}

/**
  * 処理番号TO
  */
onBlurProcessNoTo = () => {
  const {
    processNoFrom,
    processNoTo,
    setErrProcessNoFromMsgAct,
    setErrProcessNoFromFlgAct,
    setErrProcessNoToMsgAct,
    setErrProcessNoToFlgAct,
  } = this.props;
  const errMsg = [];
  if (processNoTo && processNoTo.length > 0) {
    // 文字種チェック(半角数字)
    validator.checkChar(processNoTo, VALIDATOR_CONST.PATERN_NUM, errMsg);
    // 桁数チェック
    validator.checkLength(processNoTo, 10, errMsg);
    if (errMsg.length !== 0) {
      setErrProcessNoToFlgAct(true);
      setErrProcessNoToMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
      return;
    }
    // 入力値チェック
    if (processNoFrom && processNoFrom > processNoTo) {
      setErrProcessNoFromFlgAct(true);
      setErrProcessNoToFlgAct(true);
      setErrProcessNoFromMsgAct(getMessage('FROMに、TOを超える値が入力されています。'));
      return;
    }
    if (processNoFrom && processNoFrom.length === 11 && processNoFrom <= processNoTo) {
      setErrProcessNoFromFlgAct(false);
      setErrProcessNoFromMsgAct();
    }
  }
  setErrProcessNoToFlgAct(false);
  setErrProcessNoToMsgAct();
}

  /**
  * 連携日FROM
  */
  onBlurCooperationDateFrom = () => {
    const {
      cooperationDateFrom,
      cooperationDateTo,
      setErrCooperationDateFromFlgAct,
      setErrCooperationDateFromMsgAct,
      setErrCooperationDateToFlgAct,
      setErrCooperationDateToMsgAct,
    } = this.props;

    const range = moment().subtract(3, 'M').format(DATE_TIME_FORMAT.DATE);
    const errMsg = [];

    // 連携日時FROM_入力チェック
    if (cooperationDateFrom) {
      const dateFromYYYYMMDD = moment(cooperationDateFrom).format(DATE_TIME_FORMAT.DATE);
      if (cooperationDateTo) {
        const dateToYYYYMMDD = moment(cooperationDateTo).format(DATE_TIME_FORMAT.DATE);
        if (dateFromYYYYMMDD > dateToYYYYMMDD) {
          setErrCooperationDateFromFlgAct(true);
          setErrCooperationDateFromMsgAct(
            getMessage(ERROR.E08007, INPUT.EXTERNALDATA.COOPERATIONDATE),
          );
          return;
        }
        if (dateToYYYYMMDD > range) {
          setErrCooperationDateToFlgAct(false);
          setErrCooperationDateToMsgAct();
        }
      }

      if (dateFromYYYYMMDD < range) {
        errMsg.push('3カ月以内の範囲');
        setErrCooperationDateFromFlgAct(true);
        setErrCooperationDateFromMsgAct(getMessage('3か月以内の範囲で入力してください。'));
        return;
      }
    }
    setErrCooperationDateFromFlgAct(false);
    setErrCooperationDateFromMsgAct();
  }

  /**
  * 連携日TO
  */
  onBlurCooperationDateTo = () => {
    const {
      cooperationDateFrom,
      cooperationDateTo,
      setErrCooperationDateToFlgAct,
      setErrCooperationDateToMsgAct,
      setErrCooperationDateFromFlgAct,
      setErrCooperationDateFromMsgAct,
    } = this.props;
    const range = moment().subtract(3, 'M').format(DATE_TIME_FORMAT.DATE);
    const errMsg = [];
    // 連携日時TO_入力チェック
    if (cooperationDateTo) {
      const dateToYYYYMMDD = moment(cooperationDateTo).format(DATE_TIME_FORMAT.DATE);
      if (cooperationDateFrom) {
        const dateFromYYYYMMDD = moment(cooperationDateFrom).format(DATE_TIME_FORMAT.DATE);
        if (dateFromYYYYMMDD > dateToYYYYMMDD) {
          setErrCooperationDateToFlgAct(true);
          setErrCooperationDateToMsgAct(getMessage('TOに、FROMを下回る値が入力されています。'));
          return;
        }
        if (dateFromYYYYMMDD > range) {
          setErrCooperationDateFromFlgAct(false);
          setErrCooperationDateFromMsgAct();
        }
      }

      if (dateToYYYYMMDD < range) {
        errMsg.push('3カ月以内の範囲');
        setErrCooperationDateToFlgAct(true);
        setErrCooperationDateToMsgAct(getMessage('3か月以内の範囲で入力してください。'));
        return;
      }
    }
    setErrCooperationDateToFlgAct(false);
    setErrCooperationDateToMsgAct();
  }

  /**
  * ステータス
  */

  onChangeStatusCheckBox = (num) => {
    const { setStatusAct, status } = this.props;

    // 選択したステータスを取得
    const statusItems = num;
    // ステータスリストの変数を宣言
    let newStatus = [];

    if (status.indexOf(num) === -1) {
      // 選択したステータスをステータスリストに追加
      newStatus.push(statusItems);
      // 他に選択済のステータスがある場合はステータスリストに追加
      if (status && status.length > 0) {
        newStatus = status.concat(newStatus);
      }
    } else {
      // チェックOFFに変更したステータスの配列位置を取得
      const delIndex = status.indexOf(statusItems);
      // 配列位置が取得できた場合、該当のステータスを削除
      if (delIndex >= 0) {
        newStatus = status.concat(newStatus);
        newStatus.splice(delIndex, 1);
      }
    }
    setStatusAct(newStatus);
  };

  /**
  *TSRコード文字種、桁数のチェック
  */

  onBlurTsrCd = () => {
    const {
      tsrCd,
      setErrTsrCdFlgAct,
      setErrTsrCdMsgAct,
    } = this.props;

    const errMsg = [];
    if (tsrCd && tsrCd.length > 0) {
      // 文字種チェック(半角数字)
      validator.checkChar(tsrCd, VALIDATOR_CONST.PATERN_NUM, errMsg);
      // 桁数チェック
      validator.checkLength(tsrCd, 9, errMsg);
      if (errMsg.length !== 0) {
        setErrTsrCdFlgAct(true);
        setErrTsrCdMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
        return;
      }
    }
    setErrTsrCdFlgAct(false);
    setErrTsrCdMsgAct();
  }

  /**
  *TSR企業コード文字種、桁数のチェック
  */
  onBlurTsrCompanyCd = () => {
    const {
      tsrCompanyCd,
      setErrTsrCompanyCdFlgAct,
      setErrTsrCompanyCdMsgAct,
    } = this.props;

    const errMsg = [];
    if (tsrCompanyCd && tsrCompanyCd.length > 0) {
      // 文字種チェック(半角数字)
      validator.checkChar(tsrCompanyCd, VALIDATOR_CONST.PATERN_NUM, errMsg);
      // 桁数チェック
      validator.checkLength(tsrCompanyCd, 9, errMsg);
      if (errMsg.length !== 0) {
        setErrTsrCompanyCdFlgAct(true);
        setErrTsrCompanyCdMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
        return;
      }
    }
    setErrTsrCompanyCdFlgAct(false);
    setErrTsrCompanyCdMsgAct();
  }

  /**
  *取引情報キー、最大桁数のチェック
  */
  onBlurTradeKey = () => {
    const {
      tradeKey,
      setErrTradeKeyFlgAct,
      setErrTradeKeyMsgAct,
    } = this.props;
    const errMsg = [];

    // 取引情報キー_入力チェック
    if (tradeKey && tradeKey.length > 0) {
      // 最大桁数チェック()
      validator.checkMaxLength(tradeKey, 2000, errMsg);

      if (errMsg.length !== 0) {
        setErrTradeKeyFlgAct(true);
        setErrTradeKeyMsgAct(getMessage(ERROR.E08009, errMsg.join(',')));
        return;
      }
    }
    setErrTradeKeyFlgAct(false);
    setErrTradeKeyMsgAct();
  }

  /**
   * 検索ボタン押下時の処理
   */
  onClickSearchButton = async () => {
    const {
      processNoFrom,
      processNoTo,
      cooperationDateFrom,
      cooperationDateTo,
      status,
      tsrCd,
      tsrCompanyCd,
      tradeKey,
      setSystemLodingFlgAct,
      setNowPageAct,
      setExternalDataHistoryListAct,
      searchExternalDataHistoryAct,
    } = this.props;

    await setNowPageAct(1);

    const {
      nowPage,
    } = this.props;
    setSystemLodingFlgAct(true);

    // 検索API呼び出し
    const response = await searchExternalDataHistoryAct(
      processNoFrom,
      processNoTo,
      cooperationDateFrom,
      cooperationDateTo,
      status,
      tsrCd,
      tsrCompanyCd,
      tradeKey,
      nowPage,
    );
    setSystemLodingFlgAct(false);
    setExternalDataHistoryListAct(response);
  }

  /**
  * 条件クリア
  */
  onClickClear = () => {
    // 一時保存領域条件クリア
    const {
      setInitSearchConditionAct,
      setErrorMessageAct,
      setInitExternalDataHistoryStateAct,
      setLimitMessageAct,
    } = this.props;
    setErrorMessageAct('');
    setInitSearchConditionAct();
    setInitExternalDataHistoryStateAct();
    setLimitMessageAct('');
  }

  render() {
    const {
      processNoFrom,
      processNoTo,
      cooperationDateFrom,
      cooperationDateTo,
      status,
      tsrCd,
      tsrCompanyCd,
      tradeKey,
      setProcessNoFromAct,
      setProcessNoToAct,
      setCooperationDateFromAct,
      setCooperationDateToAct,
      setTsrCdAct,
      setTsrCompanyCdAct,
      setTradeKeyAct,
      errFlg,
      errProcessNoFromMsg,
      errProcessNoToMsg,
      errCooperationDateFromMsg,
      errCooperationDateToMsg,
      errTsrCdMsg,
      errTsrCompanyCdMsg,
      errTradeKeyMsg,
    } = this.props;

    registerLocale('ja', ja);

    // status初期設定
    const statusList = [];
    for (let num = 0; num <= 3; num += 1) {
      const statusItem = EXTERNALDATA_STATUS[num];
      statusList.push(
        <FormControlLabel
          control={(
            <CustomCheckbox
              className="statusline"
              checked={status && status.indexOf(statusItem.key) >= 0}
              onClick={() => this.onChangeStatusCheckBox(statusItem.key)}
            />
          )}
          key={num}
          variant="body2"
          label={
            <Typography variant="body2">{statusItem.value}</Typography>
          }
          className="checkBox"
        />,
      );
    }

    // エラーフラグが全てTRUEの場合、押下可
    const searchErrorFlg = Object.keys(errFlg).some((key) => errFlg[key]);

    return (
      <div className="externalDataHistorySearch">
        <div className="content">
          <Box className="searchItemArea">
            <Grid container spacing={1}>
              <Box display="flex" flexDirection="column" className="searchItemLeft">
                <Typography variant="body2">処理番号</Typography>
              </Box>
              <TextField
                inputProps={{ className: 'padding' }}
                variant="outlined"
                margin="normal"
                className={errFlg.errProcessNoFromFlg ? 'processNoInput' : 'processNoInput'}
                value={processNoFrom || ''}
                onChange={(ev) => setProcessNoFromAct(ev.target.value)}
                onBlur={this.onBlurProcessNoFrom}
                error={errFlg.errProcessNoFromFlg}
              />
              {errFlg.errProcessNoFromFlg
                  && (
                  <Box className="balloon-top balloonProcessFrom">
                    <Box className="triangle">
                      <Box />
                    </Box>
                    <div className="bubble">
                      {errProcessNoFromMsg}
                    </div>
                  </Box>
                  )}
              <Box display="flex" flexDirection="column" className="kigoLayout">
                <Typography variant="body2">～</Typography>
              </Box>
              <TextField
                inputProps={{ className: 'padding' }}
                variant="outlined"
                margin="normal"
                className={errFlg.errProcessNoToFlg ? 'processNoInput' : 'processNoInput'}
                value={processNoTo || ''}
                onChange={(ev) => setProcessNoToAct(ev.target.value)}
                onBlur={this.onBlurProcessNoTo}
                error={errFlg.errProcessNoToFlg}
              />
              {errProcessNoToMsg
                  && (
                  <div className="balloon-top balloonProcessTo">
                    <div className="triangle">
                      <div />
                    </div>
                    <div className="bubble">
                      {errProcessNoToMsg}
                    </div>
                  </div>
                  )}
              <Box display="flex" flexDirection="column" className="searchItem">
                <Typography variant="body2">連携日</Typography>
              </Box>
              <DatePicker
                className={errFlg.errCooperationDateFromFlg ? 'dateInput input-error' : 'dateInput'}
                dateFormat="yyyy/MM/dd"
                locale="ja"
                selected={cooperationDateFrom || ''}
                onChange={(ev) => setCooperationDateFromAct(ev)}
                onBlur={this.onBlurCooperationDateFrom}
              />
              {errFlg.errCooperationDateFromFlg
                && (
                <div className="balloon-top balloonDate">
                  <div className="triangle">
                    <div />
                  </div>
                  <div className="bubble">
                    {errCooperationDateFromMsg}
                  </div>
                </div>
                )}
              <Box display="flex" flexDirection="column" className="kigoLayout">
                <Typography variant="body2">～</Typography>
              </Box>
              <DatePicker
                className={errFlg.errCooperationDateToFlg ? 'dateInput input-error' : 'dateInput'}
                dateFormat="yyyy/MM/dd"
                locale="ja"
                selected={cooperationDateTo || ''}
                onChange={(ev) => setCooperationDateToAct(ev)}
                onBlur={this.onBlurCooperationDateTo}
              />
              {errFlg.errCooperationDateToFlg
                && (
                <div className="balloon-top balloonDate">
                  <div className="triangle">
                    <div />
                  </div>
                  <div className="bubble">
                    {errCooperationDateToMsg}
                  </div>
                </div>
                )}
              <Box className="checkBoxArea">
                {statusList}
              </Box>
            </Grid>
          </Box>
          <Box mb={4} className="searchItemArea">
            <Grid container spacing={1} className="grid">
              <Box display="flex" flexDirection="column" className="searchItemLeft">
                <Typography variant="body2">TSRコード</Typography>
              </Box>
              <TextField
                inputProps={{ className: 'padding' }}
                variant="outlined"
                margin="normal"
                className={errFlg.errTsrCdFlg ? 'TsrCdInput' : 'TsrCdInput'}
                value={tsrCd || ''}
                onChange={(ev) => setTsrCdAct(ev.target.value)}
                onBlur={this.onBlurTsrCd}
                error={errFlg.errTsrCdFlg}
              />
              {errFlg.errTsrCdFlg
                  && (
                  <div className="balloon-top balloonCd">
                    <div className="triangle">
                      <div />
                    </div>
                    <div className="bubble">
                      {errTsrCdMsg}
                    </div>
                  </div>
                  )}
              <Box display="flex" flexDirection="column" className="searchItem">
                <Typography variant="body2">TSR企業コード</Typography>
              </Box>
              <TextField
                variant="outlined"
                margin="normal"
                inputProps={{ className: 'padding' }}
                className={errFlg.errTsrCompanyCdFlg ? 'TsrCdInput' : 'TsrCdInput'}
                value={tsrCompanyCd || ''}
                onChange={(ev) => setTsrCompanyCdAct(ev.target.value)}
                onBlur={this.onBlurTsrCompanyCd}
                error={errFlg.errTsrCompanyCdFlg}
              />
              {errFlg.errTsrCompanyCdFlg
                  && (
                  <div className="balloon-top balloonCd">
                    <div className="triangle">
                      <div />
                    </div>
                    <div className="bubble">
                      {errTsrCompanyCdMsg}
                    </div>
                  </div>
                  )}
              <Box display="flex" flexDirection="column" className="searchItem">
                <Typography variant="body2">取引情報キー</Typography>
              </Box>
              <TextField
                inputProps={{ className: 'padding' }}
                variant="outlined"
                margin="normal"
                className={errFlg.errTradeKeyFlg ? 'tradeKeyInput' : 'tradeKeyInput'}
                value={tradeKey || ''}
                onChange={(ev) => setTradeKeyAct(ev.target.value)}
                onBlur={this.onBlurTradeKey}
                error={errFlg.errTradeKeyFlg}
              />
              {errFlg.errTradeKeyFlg
                  && (
                  <div className="balloon-top balloonTradeKey">
                    <div className="triangle">
                      <div />
                    </div>
                    <div className="bubble">
                      {errTradeKeyMsg}
                    </div>
                  </div>
                  )}
              <Box className="marginAuto" />
              <Box className="buttonArea">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onClickClear}
                  startIcon={<Refresh />}
                >
                  指定条件クリア
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.onClickSearchButton}
                  disabled={searchErrorFlg}
                  className="marginLeftHalf"
                  startIcon={<Search />}
                >
                  この条件で絞り込み
                </Button>
              </Box>
            </Grid>
          </Box>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    processNoFrom: state.externaldata.processNoFrom,
    processNoTo: state.externaldata.processNoTo,
    cooperationDateFrom: state.externaldata.cooperationDateFrom,
    cooperationDateTo: state.externaldata.cooperationDateTo,
    status: state.externaldata.status,
    tsrCd: state.externaldata.tsrCd,
    tsrCompanyCd: state.externaldata.tsrCompanyCd,
    tradeKey: state.externaldata.tradeKey,
    nowPage: state.externaldata.nowPage,
    errFlg: state.externaldata.errFlg,
    errProcessNoFromMsg: state.externaldata.errProcessNoFromMsg,
    errProcessNoToMsg: state.externaldata.errProcessNoToMsg,
    errCooperationDateFromMsg: state.externaldata.errCooperationDateFromMsg,
    errCooperationDateToMsg: state.externaldata.errCooperationDateToMsg,
    errTsrCdMsg: state.externaldata.errTsrCdMsg,
    errTsrCompanyCdMsg: state.externaldata.errTsrCompanyCdMsg,
    errExternalDataNameMsg: state.externaldata.errExternalDataNameMsg,
    errExchangeDateFromMsg: state.externaldata.errExchangeDateFromMsg,
    errExchangeDateToMsg: state.externaldata.errExchangeDateToMsg,
    errTradeKeyMsg: state.externaldata.errTradeKeyMsg,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setNowPageAct: (str) => dispatch(setNowPage(str)),
    setErrorMessageAct: (str) => dispatch(setErrorMessage(str)),
    searchExternalDataHistoryAct: (
      processNoFrom, processNoTo, cooperationDateFrom, cooperationDateTo, status,
      tsrCd, tsrCompanyCd, tradeKey, nowPage,
    ) => dispatch(searchExternalDataHistory(
      processNoFrom, processNoTo, cooperationDateFrom, cooperationDateTo, status,
      tsrCd, tsrCompanyCd, tradeKey, nowPage,
    )),
    setProcessNoFromAct: (str) => dispatch(setProcessNoFrom(str)),
    setProcessNoToAct: (str) => dispatch(setProcessNoTo(str)),
    setCooperationDateFromAct:
      (cooperationDateFrom) => dispatch(setCooperationDateFrom(cooperationDateFrom)),
    setCooperationDateToAct: (str) => dispatch(setCooperationDateTo(str)),
    setStatusAct: (obj) => dispatch(setStatus(obj)),
    setTsrCdAct: (str) => dispatch(setTsrCd(str)),
    setTsrCompanyCdAct: (str) => dispatch(setTsrCompanyCd(str)),
    setTradeKeyAct: (str) => dispatch(setTradeKey(str)),
    setExternalDataHistoryListAct: (str) => dispatch(setExternalDataHistoryList(str)),
    setInitExternalDataHistoryStateAct: () => dispatch(setInitExternalDataHistoryState()),
    setInitSearchConditionAct: () => dispatch(setInitSearchCondition()),
    setErrProcessNoFromMsgAct: (str) => dispatch(setErrProcessNoFromMsg(str)),
    setErrProcessNoToMsgAct: (str) => dispatch(setErrProcessNoToMsg(str)),
    setErrCooperationDateFromMsgAct: (str) => dispatch(setErrCooperationDateFromMsg(str)),
    setErrCooperationDateToMsgAct: (str) => dispatch(setErrCooperationDateToMsg(str)),
    setErrTsrCdMsgAct: (str) => dispatch(setErrTsrCdMsg(str)),
    setErrTsrCompanyCdMsgAct: (str) => dispatch(setErrTsrCompanyCdMsg(str)),
    setErrTradeKeyMsgAct: (str) => dispatch(setErrTradeKeyMsg(str)),
    setErrProcessNoFromFlgAct: (str) => dispatch(setErrProcessNoFromFlg(str)),
    setErrProcessNoToFlgAct: (str) => dispatch(setErrProcessNoToFlg(str)),
    setErrCooperationDateFromFlgAct: (bool) => dispatch(setErrCooperationDateFromFlg(bool)),
    setErrCooperationDateToFlgAct: (bool) => dispatch(setErrCooperationDateToFlg(bool)),
    setErrTsrCdFlgAct: (bool) => dispatch(setErrTsrCdFlg(bool)),
    setErrTsrCompanyCdFlgAct: (bool) => dispatch(setErrTsrCompanyCdFlg(bool)),
    setErrTradeKeyFlgAct: (bool) => dispatch(setErrTradeKeyFlg(bool)),
    setLimitMessageAct: (str) => dispatch(setLimitMessage(str)),
    startImportPollingAct: () => dispatch(startImportPolling()),
    stopImportPollingAct: () => dispatch(stopImportPolling()),
  }),
)(ExternalDataHistorySearchComponent);
